"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationMessages = exports.t = exports.isText = exports.isRequired = exports.isRange = exports.isNumber = exports.isEmail = exports.hasPattern = exports.getAlias = exports.defaultValidations = void 0;
const isRequired = requiredMessage => ({
  required: requiredMessage
});
exports.isRequired = isRequired;
const isText = (requiredMessage, min, minMessage, max, maxMessage) => ({
  required: requiredMessage,
  minLength: {
    value: min,
    message: minMessage
  },
  maxLength: {
    value: max,
    message: maxMessage
  }
});
exports.isText = isText;
const isEmail = (requiredMessage, validEmailMessage) => ({
  required: requiredMessage,
  pattern: {
    value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    message: validEmailMessage
  }
});
exports.isEmail = isEmail;
const getComparison = (compareCondition, compareValue) => {
  switch (compareCondition) {
    case 'eq':
      return value => value === compareValue;
    case 'gt':
      return value => value > compareValue;
    case 'lt':
      return value => value < compareValue;
    case 'gte':
      return value => value >= compareValue;
    case 'lte':
      return value => value <= compareValue;
    default:
      return () => false;
  }
};
const isNumber = (requiredMessage, compareCondition, compareValue, compareValueMessage) => {
  const comparison = getComparison(compareCondition, compareValue);
  if (['eq', 'gt', 'gte', 'lt', 'lte'].includes(compareCondition)) {
    return {
      required: requiredMessage,
      validate: value => comparison(value) || compareValueMessage
    };
  }
  return null;
};
exports.isNumber = isNumber;
const isRange = (requiredMessage, min, max, minmaxMessage) => {
  const isBetween = value => min <= value && value <= max;
  return {
    required: requiredMessage,
    validate: value => isBetween(value) || minmaxMessage
  };
};
exports.isRange = isRange;
const hasPattern = (requiredMessage, regExPattern, validPattern) => ({
  required: requiredMessage,
  pattern: {
    value: regExPattern,
    message: validPattern
  }
});

// export const toCompare = (requiredMessage) => ({
//   required: requiredMessage,
//   validate: (value) => console.log(value),
// });

// const isEven = (score) => score % 2 === 0;

// const emailIsUnique = async (email) => {
//   await wait(1000);
//   return email !== 'someone@somewhere.com';
// };

// const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
exports.hasPattern = hasPattern;
const validationMessages = exports.validationMessages = {
  required: '{{label}} is required',
  min: '{{label}} has a minimum of {{min}}',
  max: '{{label}} has a maximum of {{max}}',
  pattern: 'Invalid value specified',
  minLength: '{{label}} must be at least {{minLength}} characters in length'
};
const valueAliases = {
  label: 'Field'
};
const getAlias = name => {
  return valueAliases[name];
};
exports.getAlias = getAlias;
const t = (message, values) => {
  const regexp = /{{([a-zA-Z0-9]+)}}/g;
  let matchs = [];
  let group = regexp.exec(message);
  while (group !== null) {
    matchs.push(group[1]);
    group = regexp.exec(message);
  }
  let translation = message;
  const maxReplaces = 1000;
  if (matchs && matchs.length > maxReplaces) {
    matchs = matchs.slice(0, maxReplaces);
  }
  if (matchs) {
    matchs.forEach(match => {
      if (values && Object.keys(values).includes(match)) {
        translation = translation.replace(`{{${match}}}`, values[match]);
      } else if (values && getAlias(match)) {
        translation = translation.replace(`{{${match}}}`, getAlias(match));
      }
    });
  }
  return translation;
};
exports.t = t;
const defaultValidations = exports.defaultValidations = {
  required: {
    event: ['blur', 'change'],
    name: 'required',
    validate: (value, props) => {
      return value ? {
        validator: 'required',
        valid: true
      } : {
        name: 'required',
        valid: false,
        error: t(validationMessages.required, {
          ...props
        })
      };
    }
  },
  min: {
    event: ['blur', 'change'],
    name: 'min',
    validate: (value, props) => {
      return value >= props.min ? {
        name: 'min',
        valid: true
      } : {
        name: 'min',
        valid: false,
        error: t(validationMessages.min, props)
      };
    }
  },
  max: {
    event: ['blur', 'change'],
    name: 'max',
    validate: (value, props) => {
      return value <= props.max ? {
        name: 'max',
        valid: true
      } : {
        name: 'max',
        valid: false,
        error: t(validationMessages.max, props)
      };
    }
  },
  minLength: {
    event: ['blur', 'change'],
    name: 'minLength',
    validate: (value, props) => {
      return value.length >= props.minLength ? {
        name: 'minLength',
        valid: true
      } : {
        name: 'minLength',
        valid: false,
        error: t(validationMessages.minLength, props)
      };
    }
  },
  pattern: {
    event: ['blur', 'change'],
    name: 'pattern',
    validate: (value, props) => {
      const regexp = new RegExp(props.pattern);
      return value.match(regexp) ? {
        name: 'pattern',
        valid: true
      } : {
        name: 'pattern',
        valid: false,
        error: t(props.patternErrorText || validationMessages.pattern, props)
      };
    }
  }
};
//# sourceMappingURL=validations.js.map